import React from 'react';
import { Form, Card } from 'react-bootstrap';
import ModeComponent from '../../ModeComponent';

export default class VacationTime extends ModeComponent {
  // properties set on each mount
  clockType = 'employees';
  defaultFocus = 'startDate';
  mode = 'VA';

  schema = {
    startDate: {
      errorText: 'mm-dd-yy format required field',
      label: 'Start Date',
      pikaday: true,
      required: true,
      regex: /^\d\d-\d\d-\d\d$/,
    },
    endDate: {
      errorText: 'mm-dd-yy format required field',
      label: 'End Date',
      pikaday: true,
      required: true,
      regex: /^\d\d-\d\d-\d\d$/,
    },
  };

  state = {
    startDate: {
      value: '',
      validationState: null,
    },
    endDate: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.validatedTextInput('startDate')}
            {this.validatedTextInput('endDate')}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
